"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesperateMeasures = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const TileType_1 = require("../../TileType");
const AresHandler_1 = require("../../ares/AresHandler");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class DesperateMeasures extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DESPERATE_MEASURES,
            cost: 1,
            tr: { tr: 1 },
            metadata: {
                cardNumber: 'A04',
                description: 'Place a bronze cube on a dust storm tile and raise oxygen 1 step, or place a bronze cube on an erosion tile and raise the temperature 1 step. The hazard tile with the bronze cube cannot be removed.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.resourceCube().asterix().br;
                    b.temperature(1).slash().oxygen(1);
                }),
                victoryPoints: -2,
            },
        });
    }
    getHazardTiles(game) {
        return game.board.spaces.filter((space) => AresHandler_1.AresHandler.hasHazardTile(space));
    }
    canPlay(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const oxygenLevel = player.game.getOxygenLevel();
        const temperature = player.game.getTemperature();
        let trGainFromTemperatureRaise = player.computeTerraformRatingBump(this);
        if (redsAreRuling && temperature === -2)
            trGainFromTemperatureRaise += 1;
        let trGainFromOxygenRaise = player.computeTerraformRatingBump(this);
        if (redsAreRuling && oxygenLevel === 7)
            trGainFromOxygenRaise += 1;
        const minTRGain = Math.min(trGainFromTemperatureRaise, trGainFromOxygenRaise);
        const maxTRGain = Math.max(trGainFromTemperatureRaise, trGainFromOxygenRaise);
        Card_1.Card.setRedsWarningText(player, maxTRGain, this, minTRGain !== maxTRGain);
        const hasHazardTileInPlay = this.getHazardTiles(player.game).length > 0;
        if (!hasHazardTileInPlay)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: minTRGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetailsForRaisingTemperature = this.getActionDetailsForRaisingTemperature(player, this);
            const actionDetailsForRaisingOxygen = this.getActionDetailsForRaisingOxygen(player, this);
            const hazardTileSpaces = this.getHazardTiles(player.game);
            if (hazardTileSpaces.some((space) => space.tile.tileType === TileType_1.TileType.DUST_STORM_MILD || space.tile.tileType === TileType_1.TileType.DUST_STORM_SEVERE)) {
                this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetailsForRaisingOxygen);
                if (this.howToAffordReds.redTaxes > constants_1.REDS_RULING_POLICY_COST && hazardTileSpaces.some((space) => space.tile.tileType === TileType_1.TileType.EROSION_MILD || space.tile.tileType === TileType_1.TileType.EROSION_SEVERE)) {
                    const howToAffordRedsForTemperatureIncrease = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetailsForRaisingTemperature);
                    if (howToAffordRedsForTemperatureIncrease.redTaxes < this.howToAffordReds.redTaxes) {
                        this.howToAffordReds = howToAffordRedsForTemperatureIncrease;
                    }
                }
            }
            else {
                this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetailsForRaisingTemperature);
            }
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const game = player.game;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        let eligibleHazards = this.getHazardTiles(player.game);
        const temperature = game.getTemperature();
        let raiseTemperatureCost = constants_1.REDS_RULING_POLICY_COST;
        if (temperature === -2) {
            raiseTemperatureCost += constants_1.REDS_RULING_POLICY_COST;
        }
        else if (this.temperatureIsMaxed(game) || !redsAreRuling) {
            raiseTemperatureCost = 0;
        }
        if (redsAreRuling && !player.canAfford(raiseTemperatureCost)) {
            eligibleHazards = eligibleHazards.filter((hazard) => hazard.tile.tileType !== TileType_1.TileType.EROSION_MILD && hazard.tile.tileType !== TileType_1.TileType.EROSION_SEVERE);
        }
        const oxygenLevel = game.getOxygenLevel();
        let raiseOxygenCost = constants_1.REDS_RULING_POLICY_COST;
        if (oxygenLevel === 7) {
            raiseOxygenCost += constants_1.REDS_RULING_POLICY_COST;
            if (temperature === -2)
                raiseOxygenCost += constants_1.REDS_RULING_POLICY_COST;
        }
        else if (this.oxygenIsMaxed(game) || !redsAreRuling) {
            raiseOxygenCost = 0;
        }
        if (redsAreRuling && !player.canAfford(raiseOxygenCost)) {
            eligibleHazards = eligibleHazards.filter((hazard) => hazard.tile.tileType !== TileType_1.TileType.DUST_STORM_MILD && hazard.tile.tileType !== TileType_1.TileType.DUST_STORM_SEVERE);
        }
        return new SelectSpace_1.SelectSpace('Select a hazard space to protect', eligibleHazards, TileType_1.TileType.DUST_STORM_MILD, (space) => {
            space.tile.protectedHazard = true;
            const tileType = space.tile.tileType;
            if (TileType_1.TileType.DUST_STORM_MILD === tileType || TileType_1.TileType.DUST_STORM_SEVERE === tileType) {
                player.game.increaseOxygenLevel(player, 1);
            }
            else {
                player.game.increaseTemperature(player, 1);
            }
            return undefined;
        });
    }
    getVictoryPoints() {
        return -2;
    }
    temperatureIsMaxed(game) {
        return game.getTemperature() === constants_1.MAX_TEMPERATURE;
    }
    oxygenIsMaxed(game) {
        return game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL;
    }
    getActionDetailsForRaisingTemperature(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, temperatureIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
    getActionDetailsForRaisingOxygen(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromOxygenIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, oxygenIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.DesperateMeasures = DesperateMeasures;
//# sourceMappingURL=DesperateMeasures.js.map